export default __webpack_public_path__ + "static/media/frame_ko_pc.c69099bb.png";